import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.843 20.822a.5.5 0 0 1-.004.707l-2.896 2.864a.5.5 0 0 1-.701.002l-1.416-1.383a.5.5 0 0 1 .698-.716l1.065 1.04 2.547-2.518a.5.5 0 0 1 .707.004M17.654 12.468a.5.5 0 0 0 0 1h4.628a.5.5 0 1 0 0-1zM17.154 15.617a.5.5 0 0 1 .5-.5h2.878a.5.5 0 1 1 0 1h-2.878a.5.5 0 0 1-.5-.5M23.386 20.524a.5.5 0 1 0-.918-.396l-1.191 2.77-1.75-1.794a.5.5 0 0 0-.82.16l-.553 1.355v-2.99a.5.5 0 1 0-1 0v5.85h6.054a.5.5 0 1 0 0-1h-4.732l.869-2.13 1.738 1.782a.5.5 0 0 0 .817-.152zM15.291 4.197a.75.75 0 0 0 0 1.5h2.414a.75.75 0 0 0 0-1.5zM12.99 13.109a.5.5 0 0 0-.702-.711L9.74 14.916l-1.065-1.04a.5.5 0 1 0-.699.715l1.416 1.384a.5.5 0 0 0 .701-.002z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.287 1.902c-.69 0-1.25.56-1.25 1.25v1.113H6.738c-.69 0-1.25.56-1.25 1.25v6.682a5.4 5.4 0 0 0-.38 1.988c0 1.241.42 2.384 1.127 3.293L2.721 20.88a.75.75 0 1 0 1.043 1.078l1.724-1.668v6.56c0 .69.56 1.25 1.25 1.25h19.52c.69 0 1.25-.56 1.25-1.25V5.514c0-.69-.56-1.25-1.25-1.25h-5.3V3.152c0-.69-.559-1.25-1.25-1.25zM6.988 18.837l.323-.312a5.375 5.375 0 1 0-.323-8.423V5.765H9.28v.714c0 .967.783 1.75 1.75 1.75h10.936a1.75 1.75 0 0 0 1.75-1.75v-.714h2.292v20.833H6.988zM10.78 6.479v-.714h1.507c.69 0 1.25-.56 1.25-1.25V3.402h5.922v1.113c0 .69.56 1.25 1.25 1.25h1.507v.714a.25.25 0 0 1-.25.25H11.03a.25.25 0 0 1-.25-.25m-4.172 7.706a3.875 3.875 0 1 1 7.75 0 3.875 3.875 0 0 1-7.75 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }